import { PostType } from '../types/post';

/**
 * Map of uppercase post type keys to their display values.
 * Used for consistent post type lookups across the application.
 * Keys are uppercase versions of the PostType values.
 */
export const POST_TYPES: Record<Uppercase<PostType>, PostType> = Object.freeze({
  STANDARD: 'Standard',
  FEATURED: 'Featured',
  PREMIERE: 'Premiere',
  SPONSORED: 'Sponsored',
  SUBMITTED: 'Submitted',
  PROMOTED: 'Promoted',
} as const);
